export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const INIT_LOGIN_REQUEST = "INIT_LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const RESET_LOGIN_STATE = "RESET_LOGIN_STATE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";